import { Box, Typography, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField } from '@mui/material';
import { Edit, Delete, Visibility, CheckCircle } from '@mui/icons-material';
import { Temple } from '../../types';

interface TemplesTableProps {
  temples: Temple[];
  loading: boolean;
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onEdit: (temple: Temple) => void;
  onDelete: (id: number) => void;
  onToggleActive: (id: number) => void;
}

export function TemplesTable({ temples, loading, total, page, limit, onPageChange, onEdit, onDelete, onToggleActive }: TemplesTableProps) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Название</TableCell>
            <TableCell>Адрес</TableCell>
            <TableCell>Телефон</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {temples.map((temple) => (
            <TableRow key={temple.id} hover>
              <TableCell>{temple.name}</TableCell>
              <TableCell>{temple.address || '-'}</TableCell>
              <TableCell>{temple.phone || '-'}</TableCell>
              <TableCell>
                <Chip 
                  label={temple.isActive ? 'Активен' : 'Неактивен'} 
                  size="small" 
                  color={temple.isActive ? 'success' : 'default'}
                />
              </TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Просмотр">
                    <IconButton size="small" onClick={() => onEdit(temple)}>
                      <Visibility fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Редактировать">
                    <IconButton size="small" onClick={() => onEdit(temple)}>
                      <Edit fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={temple.isActive ? 'Деактивировать' : 'Активировать'}>
                    <IconButton size="small" onClick={() => onToggleActive(temple.id)}>
                      <CheckCircle fontSize="small" color={temple.isActive ? 'success' : 'disabled'} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Удалить">
                    <IconButton size="small" onClick={() => onDelete(temple.id)} sx={{ color: 'error.main' }}>
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {temples.length === 0 && !loading && (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography color="text.secondary">Храмы не найдены</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={total}
        page={page - 1}
        onPageChange={(_, newPage) => onPageChange(newPage + 1)}
        rowsPerPage={limit}
        onRowsPerPageChange={() => {}}
        rowsPerPageOptions={[]}
      />
    </TableContainer>
  );
}

interface TemplesToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
}

export function TemplesToolbar({ search, onSearchChange }: TemplesToolbarProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2, alignItems: 'center' }}>
      <TextField
        label="Поиск"
        variant="outlined"
        size="small"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ minWidth: 200 }}
      />
      {search && (
        <Box sx={{ borderLeft: '1px solid #ccc', ml: 1, pl: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Активен поиск
          </Typography>
        </Box>
      )}
    </Box>
  );
}
